import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { generateEmptyWorkspace } from '../../DesktopOnboardingWizard/Workspaces/utils';
import ContentWrapper from '../Wrappers/ContentWrapper/ContentWrapper';
import { WorkspacesType } from '../../types';
import FormFields from './FormFields/FormFields';
import './Workspaces.scss';

type Props = {
  workspaces: WorkspacesType;
  advanceOnboardingState: Function;
  numDirectReports: number;
};

function Workspaces({
  workspaces: initWorkspaces,
  advanceOnboardingState,
  numDirectReports: initNumDirectReports,
}: Props) {
  const handleNextStep = useCallback(
    ({ workspaces, numDirectReports }) => {
      return advanceOnboardingState({
        workspaces: [...workspaces.filter(({ uuid, fullName }) => uuid && fullName)],
        num_direct_reports: numDirectReports,
      });
    },
    [advanceOnboardingState]
  );

  const formValidate = useCallback(values => {
    if (values.workspaces && values.workspaces.some(item => item.fullName)) return {};
    return { error: 'Required field' };
  }, []);

  const noMeetingsFoundAfterConnectCalendar = useSelector(
    state =>
      state.onboardingState?.flowType === 'mobile_calendar_integration' &&
      state.onboardingState?.recurringMeetings?.filter(({ isGroup }) => !isGroup)?.length === 0 &&
      state.onboardingState?.userCreatedInMiddle
  );

  const description = noMeetingsFoundAfterConnectCalendar
    ? 'We couldn’t find any 1:1 meetings in your calendar. Let’s manually create some workspaces instead.'
    : 'Nice Work! \nLet’s create workspaces for all your 1:1’s.';

  return (
    <ContentWrapper
      initialValues={{
        workspaces: initWorkspaces.length ? initWorkspaces : [generateEmptyWorkspace()],
        numDirectReports: initNumDirectReports ? String(initNumDirectReports) : null,
      }}
      formValidate={formValidate}
      title="Workspaces"
      description={description}
      onNextStep={handleNextStep}
    >
      <FormFields />
    </ContentWrapper>
  );
}

export default Workspaces;
